/**
 * Uber Freight detail API — fetches single-offer details on demand.
 */

import { loadsIngestServiceAxios } from '@/setup/SetupAxios'

export async function fetchUberFreightOfferDetail(offerUUID: string): Promise<unknown | null> {
    if (!offerUUID) return null
    const response = await loadsIngestServiceAxios.get<{ success: boolean; data: unknown | null }>(
        `/loads/loadboards/uber-freight/offer/${encodeURIComponent(offerUUID)}`
    )
    return response.data?.data ?? null
}
